"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seatsTariffOrder = void 0;
exports.seatsTariffOrder = [
    'totalSeats',
    'costPerSeat',
    'agentSeatsLimit',
    'onlineSeatsLimit',
];
//# sourceMappingURL=utils.js.map